"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conciergeDeleteWorkOrderBid = exports.conciergeUpdateWorkOrderBid = exports.conciergeCreateWorkOrderBid = exports.conciergeGetWorkOrderBidsByConciergeVendorId = exports.conciergeGetWorkOrderBidsByBidRequestId = exports.conciergeGetWorkOrderBidById = void 0;
const client_1 = require("@apollo/client");
const fragments_graphql_1 = require("../fragments.graphql");
exports.conciergeGetWorkOrderBidById = (0, client_1.gql) `
  ${fragments_graphql_1.CONCIERGE_WORK_ORDER_BID_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONTACT_FIELDS}
  ${fragments_graphql_1.ATTACHMENT_FIELDS}
  query conciergeGetWorkOrderBidById($id: ID!) {
    conciergeGetWorkOrderBidById(id: $id) {
      ...ConciergeWorkOrderBidFields
      conciergeVendor {
        ...ConciergeVendorFields
      }
      conciergeVendorContact {
        ...ConciergeVendorContactFields
      }
      attachments {
        ...AttachmentFields
      }
    }
  }
`;
exports.conciergeGetWorkOrderBidsByBidRequestId = (0, client_1.gql) `
  ${fragments_graphql_1.CONCIERGE_WORK_ORDER_BID_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONTACT_FIELDS}
  ${fragments_graphql_1.ATTACHMENT_FIELDS}
  query conciergeGetWorkOrderBidsByBidRequestId($id: ID!) {
    conciergeGetWorkOrderBidsByBidRequestId(id: $id) {
      ...ConciergeWorkOrderBidFields
      conciergeVendor {
        ...ConciergeVendorFields
      }
      conciergeVendorContact {
        ...ConciergeVendorContactFields
      }
      attachments {
        ...AttachmentFields
      }
    }
  }
`;
exports.conciergeGetWorkOrderBidsByConciergeVendorId = (0, client_1.gql) `
  ${fragments_graphql_1.CONCIERGE_WORK_ORDER_BID_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONTACT_FIELDS}
  ${fragments_graphql_1.ATTACHMENT_FIELDS}
  query conciergeGetWorkOrderBidsByConciergeVendorId($id: ID!) {
    conciergeGetWorkOrderBidsByConciergeVendorId(id: $id) {
      ...ConciergeWorkOrderBidFields
      conciergeVendor {
        ...ConciergeVendorFields
      }
      conciergeVendorContact {
        ...ConciergeVendorContactFields
      }
      attachments {
        ...AttachmentFields
      }
    }
  }
`;
exports.conciergeCreateWorkOrderBid = (0, client_1.gql) `
  mutation conciergeCreateWorkOrderBid($input: WorkOrderBidCreateInput!) {
    conciergeCreateWorkOrderBid(input: $input) {
      id
    }
  }
`;
exports.conciergeUpdateWorkOrderBid = (0, client_1.gql) `
  mutation conciergeUpdateWorkOrderBid($id: ID!, $input: WorkOrderBidUpdateInput!) {
    conciergeUpdateWorkOrderBid(id: $id, input: $input) {
      id
    }
  }
`;
exports.conciergeDeleteWorkOrderBid = (0, client_1.gql) `
  mutation conciergeDeleteWorkOrderBid($id: ID!) {
    conciergeDeleteWorkOrderBid(id: $id) {
      id
    }
  }
`;
//# sourceMappingURL=work-order-bid.queries.graphql.js.map